import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './components/Login';
import Inicio from './components/Inicio';
import Horario from './components/Horario';
import Colillas from './components/Colillas';
import Notificaciones from './components/Notificaciones';
import Perfil from './components/Perfil';

function RutaProtegida({ children }) {
  const { usuario, cargando } = useAuth();
  if (cargando) return <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', color:'#9CA3AF' }}>Cargando...</div>;
  if (!usuario) return <Navigate to="/login" />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<RutaProtegida><Inicio /></RutaProtegida>} />
      <Route path="/horario" element={<RutaProtegida><Horario /></RutaProtegida>} />
      <Route path="/colillas" element={<RutaProtegida><Colillas /></RutaProtegida>} />
      <Route path="/notificaciones" element={<RutaProtegida><Notificaciones /></RutaProtegida>} />
      <Route path="/perfil" element={<RutaProtegida><Perfil /></RutaProtegida>} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default function App() {
  useEffect(() => {
    // Registrar Service Worker
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js')
        .then(reg => console.log('SW registrado:', reg.scope))
        .catch(err => console.log('SW error:', err));
    }
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-center" toastOptions={{ duration: 3000, style: { borderRadius: '12px', fontSize: '14px' } }} />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
